import React from 'react'

type Affiliate = {
  code?: string | null
  name?: string | null
  email?: string | null
  commission?: string | null
}

export default function AffiliateInfoCard({ affiliate }: { affiliate: Affiliate }) {
  if (!affiliate) return null
  const label = affiliate.name || affiliate.email || affiliate.code || 'Afiliado'
  return (
    <div className="rounded-xl border border-border p-4">
      <div className="mb-2 text-sm font-medium">Vinculo de afiliacao</div>
      <div className="text-sm text-foreground/80 space-y-1">
        <div>
          Indicado por: <span className="font-medium">{label}</span>
        </div>
        {!!affiliate.code && (
          <div>
            Codigo: <span className="font-mono">{affiliate.code}</span>
          </div>
        )}
        {!!affiliate.commission && (
          <div>
            Comissao do afiliado: <span className="font-medium">{affiliate.commission}</span>
          </div>
        )}
        <div className="text-xs text-foreground/60">
          A comissao sera gerada apos confirmacao do pagamento.
        </div>
      </div>
    </div>
  )
}

